var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _g2, _path1, _path10, _g3, _g4, _ellipse, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoproductfound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 180,
    viewBox: "0 0 153 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4849 105.661V155.004L76.4669 179.675V130.228L25.4849 105.661Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M25.4849 105.661V155.004L76.4669 179.675V130.228L25.4849 105.661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.449 105.661V155.004L76.4668 179.675V130.228L127.449 105.661Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.449 105.661V155.004L76.4668 179.675V130.228L127.449 105.661Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9759 117.945L25.4849 105.661L76.4669 81.2769V130.228L50.9759 117.945Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.9759 117.945L25.4849 105.661L76.4669 81.2769V130.228L50.9759 117.945Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4668 81.2769V130.228L127.449 105.661L76.4668 81.2769Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.4668 81.2769V130.228L127.449 105.661L76.4668 81.2769Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.452 81.2772L50.989 93.3822L25.511 105.661L0 93.3822L51.683 69.1582L76.452 81.2772Z",
    fill: "#909090"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.452 81.2772L50.989 93.3822L25.511 105.661L0 93.3822L51.683 69.1582L76.452 81.2772Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M152.92 93.558L127.442 81.279L101.963 69L76.4521 81.279L127.449 105.753L152.92 93.558Z",
    fill: "#909090"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.92 93.558L127.442 81.279L101.963 69L76.4521 81.279L127.449 105.753L152.92 93.558Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.467 130.31L50.989 118.032L25.511 105.753L0 118.032L51.683 142.255L76.467 130.31Z",
    fill: "#909090"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.935 117.697L127.457 129.976L101.978 142.255L76.4668 129.976L127.449 105.661L152.935 117.697Z",
    fill: "#909090"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.935 117.697L127.457 129.976L101.978 142.255L76.4668 129.976L127.449 105.661L152.935 117.697Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.467 130.31L50.989 118.032L25.511 105.753L0 118.032L51.683 142.255L76.467 130.31Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 92.5,
    cy: 24,
    rx: 24.5,
    ry: 24,
    fill: "#5070DE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0519 26.0519L77.6769 33.6769M77.6769 26.0519L70.0519 33.6769M86.9362 43.0048L94.7645 50.8332M92.2915 29.229C92.2915 34.2847 90.2831 39.1333 86.7082 42.7082C83.1333 46.2831 78.2847 48.2915 73.229 48.2915C68.1733 48.2915 63.3247 46.2831 59.7498 42.7082C56.1749 39.1333 54.1665 34.2847 54.1665 29.229C54.1665 24.1733 56.1749 19.3247 59.7498 15.7498C63.3247 12.1749 68.1733 10.1665 73.229 10.1665C78.2847 10.1665 83.1333 12.1749 86.7082 15.7498C90.2831 19.3247 92.2915 24.1733 92.2915 29.229Z",
    stroke: "#5070DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoproductfound);
export default __webpack_public_path__ + "static/media/noproductfound.3205878c04b86205636042f017081161.svg";
export { ForwardRef as ReactComponent };